import { useEffect, useState } from "react";
import client from "../lib/api";
import { ChevronDown, Check } from "lucide-react";

/* Smart category combobox — curated suggestions + freeform.
 * Returns the chosen category as a plain string via onChange.
 */
export default function CategorySelect({ value, onChange, testid = "category-select" }) {
  const [suggestions, setSuggestions] = useState([]);
  const [used, setUsed] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    client.get("/videos/categories/suggested").then((r) => setSuggestions(r.data));
    client.get("/videos/categories").then((r) => setUsed(r.data));
  }, []);

  // Merge suggestions with already-used (avoid duplicates)
  const all = [
    ...suggestions,
    ...used.filter((u) => !suggestions.find((s) => s.key.toLowerCase() === u.toLowerCase()))
      .map((u) => ({ key: u, label: u, description: "Existing" })),
  ];

  return (
    <div className="relative" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full h-11 px-4 bg-zinc-900/70 border border-white/10 hover:border-white/30 focus:border-[#FF6B00] outline-none rounded-lg text-white text-sm flex items-center justify-between"
        data-testid={`${testid}-toggle`}
      >
        <span className="truncate">{value || "Select category"}</span>
        <ChevronDown className={`w-4 h-4 text-zinc-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div className="absolute z-30 mt-1 w-full max-h-72 overflow-auto rounded-lg bg-[#0a0a0a] border border-white/10 shadow-2xl">
          <input
            autoFocus
            type="text"
            placeholder="Type a custom category..."
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            className="w-full h-10 px-3 bg-transparent border-b border-white/10 text-white text-sm outline-none placeholder:text-zinc-600"
            data-testid={`${testid}-input`}
          />
          {all.map((opt) => (
            <button
              type="button"
              key={opt.key}
              onClick={() => { onChange(opt.label); setOpen(false); }}
              data-testid={`${testid}-opt-${opt.key}`}
              className="w-full text-left px-3 py-2 hover:bg-[#FF6B00]/10 flex items-center justify-between group"
            >
              <div>
                <p className="text-sm font-bold text-white group-hover:text-[#FFB800]">{opt.label}</p>
                <p className="text-[10px] text-zinc-500">{opt.description}</p>
              </div>
              {value === opt.label && <Check className="w-4 h-4 text-[#FFB800]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
